import { skapi } from "@/main";

let processing: Promise<void> | null = null;
export async function miscUpdater(toUpdate: any): Promise<void> {
    if (processing) await processing;

    const nextUpdate = { ...toUpdate };

    processing = (async () => {
        const getProfile = await skapi.getProfile();

        if (!getProfile) {
            // 프로필이 없는 경우 (로그인 안됨 등)
            throw new Error("User profile not available");
        }

        let currentMisc: Record<string, any> = {};
        if (getProfile.misc && typeof getProfile.misc === "string") {
            try {
                currentMisc = JSON.parse(getProfile.misc);
            } catch {
                currentMisc = {};
            }
        }

        for (let key in nextUpdate) {
            if (nextUpdate[key] === null) {
                delete currentMisc[key];
                continue;
            }

            currentMisc[key] = nextUpdate[key];
        }

        return skapi.updateProfile({
            misc: JSON.stringify(currentMisc),
        });
    })().finally(() => {
        processing = null;
    });

    return processing;
}